import PropTypes from 'prop-types'

import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

import ImagePreview from '@aytm/app/stats/components/image-preview/ImagePreview'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

import style from '@aytm/app/stats/page/question-views/info-view/components/styles/Image.module.scss'

// Info-view image block: a single 600px image with the zoom/preview affordance.
// Replaces info_view/image.coffee's #info-view-question-block-image-template.
const Image = ({ image }) =>
  undefined != image && undefined != image.original ? (
    <BlockWrapper>
      <div className={style.component}>
        <ImagePreview
          minWidth="50px"
          maxWidth="600px"
          minHeight="50px"
          maxHeight="600px"
          imageUrl={image.original.url}
          previewUrl={getImageAssetPath({
            path: image.original.path,
            width: 600,
            height: 600,
            filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
            backgroundColor: 'white'
          })}
          allowScrolling={image.scrolling}
        />
      </div>
    </BlockWrapper>
  ) : null

Image.displayName = 'Image'

Image.propTypes = {
  image: PropTypes.object
}

export default Image
